angular.
module("dx.webapp.droparea").
constant("DX_UPLOAD_STATE", Object.freeze({
	INITIAL: 0,
	UPLOAD_PENDING: 1,
	UPLOADING: 2,
	UPLOAD_COMPLETE: 3,
}));
